module.exports = __webpack_public_path__ + "static/media/arrow_right.cd0b10dd.svg";